module.exports = __webpack_public_path__ + "img/mex.5d8bc132.svg";